/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topic_AddInputs */



/**
* | output |
* | --- |
* | "Add topic" |
*
* @param {Settings_Template_Topic_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_add = /** @type {((inputs?: Settings_Template_Topic_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Onderwerp toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un sujet")
	return /** @type {LocalizedString} */ ("Add topic")
});